export default __webpack_public_path__ + "fda55c9422ba028d2492151edc7c9a15.png";